<template>
  <div>
    <vs-card id="card-instance" class="d-inline-flex relative text-center">
      <div class="flex justify-between items-center">
        <img class="whatsapp-icon" :src="require('@/assets/images/brands/whatsapp.png')" alt="whatsapp-logo">
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <vs-button icon="icon-more-vertical" icon-pack="feather" type="flat"/>

          <vs-dropdown-menu class="select-none">
            <vs-dropdown-group vs-label="Ações">
              <vs-dropdown-item
                divider
                @click="connect(true)"
                @touchstart.prevent="connect(true)"
                :disabled="!canSee('instances-list-wpp-auth')"
                v-if="!instance.activated || !instance.is_official || (instance.is_official && !instance.integration_id)"
              >
                Conectar-se no Whatsapp
              </vs-dropdown-item>
              <vs-dropdown-item
                divider
                @click="editInstance"
                @touchstart.prevent="editInstance"
                :disabled="!canSee('instance-edit')"
                v-if="instance.activated && instance.integration_id"
              >
                Editar Conexão
              </vs-dropdown-item>
              <vs-dropdown-item
                divider
                @click="editNickname"
                @touchstart.prevent="editNickname"
                :disabled="!canSee('instance-edit')"
              >
                Mudar apelido da conexão
              </vs-dropdown-item>
              <vs-dropdown-item
                divider
                @click="closeTickets"
                @touchstart.prevent="closeTickets"
                :disabled="!canSee('chat-batch-finalize')"
              >
                Encerrar atendimentos em massa
              </vs-dropdown-item>
              <vs-dropdown-item
                divider
                @click="sendTerm"
                @touchstart.prevent="sendTerm"
                v-if="!instance.is_official"
                :disabled="!canSee('chat-lgpd-febrafar')"
              >
                Enviar termo LGPD
              </vs-dropdown-item>
            </vs-dropdown-group>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <div class="flex flex-col items-center justify-center bg-white p-4">
        <vs-td>
          <small class="text-sm">{{ currentTenant }}</small>
        </vs-td>

        <vs-td class="m-5">
          <p class="text-xl font-bold text-gray-900" :title="instance.nickname || instance.name">{{ instance.nickname || instance.name | truncate(30, true) }}</p>
          <small class="text-small" v-if="instance.nickname" :title="instance.name">{{ instance.name | truncate(30, true) }}</small>
        </vs-td>

        <vs-td class="mb-2">
          <div class="flex items-center select-none" :class="{'cursor-pointer':!instance.activated}">
            <span @click="connect()">
              <vs-chip :color="parseConnectionStatusOrColor(instance.activated, true)">
                {{ parseConnectionStatusOrColor(instance.activated, false, true) | title }}
              </vs-chip>
            </span>

            <vx-tooltip :text="getMesssageConnection(instance.activated)" position="top" >
              <feather-icon v-if="!instance.activated || incidentStatus !== 'UP'" icon="AlertTriangleIcon" size="small" svgClasses="w-7 h-7 text-warning"/>
            </vx-tooltip>

          </div>
        </vs-td>

        <vs-td class="mb-3 mt-1">
          <p class="text-base">
            {{ instance.phone_number.length >= 5 ? maskPhoneNumber(instance.phone_number) : 'Não informado' }}
          </p>
        </vs-td>

        <vs-td class="mb-2" v-if="instance.is_official">
          <div class="flex items-center">
            <p>{{ instance.messaging_send || 0 }} de {{ maskLimitMessageTemplate(instance.messaging_limit) || 0 }} conversas/24h</p>

            <vx-tooltip
              class="ml-3"
              position="bottom"
              title="Conversas Ativas"
              text="Cada conexão têm um limite de Modelo de Mensagem que podem enviar em 24 horas, baseado no número máximo de conversas que podem iniciar. Cada conversa começa com a primeira mensagem e dura 24 horas. Se o limite é atingido, a empresa deve esperar até que alguma das conversas ativas terminem antes de iniciar novas."
            >
              <feather-icon icon="HelpCircleIcon" class="flex" size="small" svgClasses="w-7 h-7"></feather-icon>
            </vx-tooltip>
          </div>
        </vs-td>
      </div>

      <footer class="flex justify-center mb-8 absolute bottom-0 left-0 right-0">
        <vs-button :disabled="lockButtons" @click="select">Escolher Conexão</vs-button>
      </footer>
    </vs-card>
  </div>
</template>

<script>
import {
  hasPermission,
  maskPhoneNumber,
  getCurrentTenant,
  maskLimitMessageTemplate,
  parseConnectionStatusOrColor
} from "@/utils";
import moduleSettings from '@/store/settings/moduleSettings';
import VsDropdown from "@/components/vs-dropdown/dropdown.vue";
import VsDropdownMenu from "@/components/vs-dropdown/dropdown-menu.vue";
import VsDropdownItem from "@/components/vs-dropdown/dropdown-item.vue";

export default {
  name: 'card-instance',
  components: {VsDropdownItem, VsDropdownMenu, VsDropdown},
  props: {
    instance: {
      required: true,
      validator: prop => typeof prop === 'object' || prop === null
    },
    lockButtons: {
      type: Boolean,
      required: false,
      default(){ return false; }
    }
  },
  computed:{
    currentTenant(){
      return getCurrentTenant()
    },
    incidentStatus() {
      return this.$store.state.settings.incidentStatus
    }
  },
  methods: {
    maskPhoneNumber,
    maskLimitMessageTemplate,
    parseConnectionStatusOrColor,
    canSee(action) {
      return hasPermission(action)
    },
    select(){
      this.$emit('selected', this.instance)
    },
    sendTerm(){
      this.$emit('send-term', this.instance)
    },
    editNickname(){
      this.$emit('edit-nickname', this.instance)
    },
    closeTickets(){
      this.$emit('close-tickets', 'instance', [this.instance.id])
    },
    editInstance(){
      this.$emit('redirect', 'edit', this.instance.id, true)
    },
    connect(always = false){
      if ( (this.instance.activated && !always) || !this.canSee('instances-list-wpp-auth')){
        return
      }

      if ( !this.instance.activated && this.instance.is_official && this.instance.integration_id ) {
        return this.$emit('redirect', 'build', this.instance.id, true)
      }

      this.$emit('connect', this.instance)
    },
    getMesssageConnection(activated) {
      if (activated) {
        return 'Atualmente estamos enfrentando um incidente. A conexão e outras funcionalidades podem apresentar lentidão.';
      }
      return 'Conexão desconectada.';
    }
  },
  created() {
    if (!moduleSettings.isRegistered) {
      this.$store.registerModule('settings', moduleSettings)
      moduleSettings.isRegistered = true
    }
  }
}
</script>

<style lang="scss">
.vs-dropdown--item .vs-dropdown--item-link {
  text-align: center !important;
}

#card-instance{
  width: 21em;
  height: 27em !important;
  word-wrap: anywhere;

  .whatsapp-icon {
    height: 4em;
    width: 4em;
  }
}
</style>
